"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Base = require("./Base");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Filter = function Filter(_ref) {
  var column = _ref.column;
  var inputRef = (0, _react.useRef)(null);
  var preFilteredRows = column.preFilteredRows,
      filterOptions = column.filterOptions,
      setFilter = column.setFilter,
      filterValue = column.filterValue;
  var type = filterOptions.type;

  var options = _react.default.useMemo(function () {
    if (type !== 'select') return [];
    var optionsSet = new Set();

    if (typeof filterOptions.options === 'function') {
      preFilteredRows.forEach(function (row) {
        optionsSet.add(filterOptions.options(row.original));
      });
    } else if (typeof filterOptions.options === 'string') {
      preFilteredRows.forEach(function (row) {
        optionsSet.add(row.original[filterOptions.options]);
      });
      optionsSet.add(preFilteredRows.map());
    } else {
      return filterOptions.options;
    }

    return _toConsumableArray(optionsSet.values()); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preFilteredRows, filterOptions.options, type]); // On mount:
  // - focus input ref
  // - register filter reset on unmount


  (0, _react.useEffect)(function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }

    return function () {
      return setFilter(undefined);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var renderOptions = function renderOptions() {
    var optionEls = options.map(function (opt) {
      var _ref2 = Array.isArray(opt) ? opt : [opt, opt],
          _ref3 = _slicedToArray(_ref2, 2),
          label = _ref3[0],
          value = _ref3[1];

      return /*#__PURE__*/_react.default.createElement("option", {
        value: value,
        key: value
      }, label);
    });
    return optionEls;
  };

  return type === 'select' ? /*#__PURE__*/_react.default.createElement(_Base.SelectFilterWrapper, null, /*#__PURE__*/_react.default.createElement(_Base.SelectFilter, {
    value: filterValue,
    onChange: function onChange(e) {
      return setFilter(e.target.value || undefined);
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    ref: inputRef
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }, "All"), renderOptions())) : /*#__PURE__*/_react.default.createElement(_Base.SearchFilter, {
    placeholder: column.filterOptions.placeholder,
    value: filterValue || '',
    onChange: function onChange(e) {
      return setFilter(e.target.value || undefined);
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    ref: inputRef
  });
};

Filter.propTypes = {
  inputRef: _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  }).isRequired
};
var _default = Filter;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/containers/data_table/Filter.js
// module id = 775
// module chunks = 0 15 16 17 18